import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ReassuranceBar from '@/components/feature/ReassuranceBar';
import ServiceCard from '@/components/feature/ServiceCard';
import CTABanner from '@/components/feature/CTABanner';
import SEOHead from '@/components/feature/SEOHead';
import { useState } from 'react';

const faqData = [
  {
    q: "Quel est le délai d'intervention pour un dépannage de volet roulant à Lyon ?",
    a: "Nous intervenons sous 24 à 48 heures après votre appel, 7 jours sur 7, dans tout Lyon et la Métropole de Lyon. Pour les urgences, nous faisons notre maximum pour intervenir le jour même selon disponibilité.",
  },
  {
    q: "Quelles zones couvrez-vous dans la Métropole de Lyon ?",
    a: "Nous intervenons dans tous les arrondissements de Lyon (du 1er au 9e) ainsi que dans toutes les communes de la métropole : Villeurbanne, Caluire-et-Cuire, Vénissieux, Bron, Vaulx-en-Velin, Saint-Priest, Tassin-la-Demi-Lune, Écully, Sainte-Foy-lès-Lyon, et bien d'autres.",
  },
  {
    q: "Le devis est-il payant ?",
    a: "Non, le devis est entièrement gratuit et sans engagement. Nous établissons un diagnostic clair de la panne ou du besoin et vous remettons un devis détaillé avant toute intervention.",
  },
  {
    q: "Quelle garantie proposez-vous sur vos réparations ?",
    a: "Toutes nos réparations sont garanties 10 ans. Cette garantie couvre les pièces remplacées et la main-d'œuvre. C'est un engagement fort qui témoigne de la qualité de notre travail.",
  },
  {
    q: "Quelles marques de volets roulants et fenêtres prenez-vous en charge ?",
    a: "Nous intervenons sur toutes les grandes marques : Somfy, Bubendorff, Profalux, Nice, Velux, Franciaflex, et bien d'autres. Nous assurons le dépannage quel que soit le type de motorisation (filaire, radio, solaire).",
  },
];

const services = [
  { icon: 'ri-home-gear-line', title: 'Volet roulant', description: 'Dépannage, réparation et motorisation de tous types de volets roulants à Lyon : manuels, électriques ou solaires.', href: '/reparation-volet-roulant-lyon/', highlighted: true },
  { icon: 'ri-window-line', title: 'Fenêtre', description: 'Réparation de fenêtres bloquées, remplacement de crémone, poignée et joint. Réglage oscillo-battant. Intervention rapide sur Lyon.', href: '/reparation-fenetre-lyon/' },
  { icon: 'ri-sun-line', title: 'Store / BSO', description: "Dépannage de stores bannes, BSO et stores intérieurs. Réparation toile, bras et motorisation.", href: '/reparation-store-lyon/' },
  { icon: 'ri-contrast-drop-line', title: 'Vitrage / Vitrier', description: 'Remplacement de vitrage cassé, double vitrage, vitrage isolant. Service vitrier d\'urgence à Lyon.', href: '/vitrier-lyon/' },
  { icon: 'ri-door-open-line', title: 'Baie vitrée & porte coulissante', description: "Réparation et réglage de baies vitrées coulissantes, portes-fenêtres. Remplacement de roulettes, serrure et joints.", href: '/reparation-baie-vitree-lyon/' },
  { icon: 'ri-shield-line', title: 'Moustiquaire', description: 'Moustiquaires sur mesure pour fenêtres, portes-fenêtres et baies vitrées. Pose soignée, toile résistante.', href: '/moustiquaire-lyon/' },
  { icon: 'ri-door-lock-line', title: 'Porte & serrure', description: 'Dépannage de porte d\'entrée, changement de serrure et barillet. Ouverture de porte bloquée, serrurier urgence.', href: '/depannage-porte-serrure-lyon/' },
];

const villes = [
  { label: 'Lyon 1er', href: '/depannage-menuiserie-lyon-1e/' },
  { label: 'Lyon 2e', href: '/depannage-menuiserie-lyon-2e/' },
  { label: 'Lyon 3e', href: '/depannage-menuiserie-lyon-3e/' },
  { label: 'Lyon 4e', href: '/depannage-menuiserie-lyon-4e/' },
  { label: 'Lyon 5e', href: '/depannage-menuiserie-lyon-5e/' },
  { label: 'Lyon 6e', href: '/depannage-menuiserie-lyon-6e/' },
  { label: 'Lyon 7e', href: '/depannage-menuiserie-lyon-7e/' },
  { label: 'Lyon 8e', href: '/depannage-menuiserie-lyon-8e/' },
  { label: 'Lyon 9e', href: '/depannage-menuiserie-lyon-9e/' },
  { label: 'Villeurbanne', href: '/depannage-menuiserie-villeurbanne/' },
  { label: 'Caluire-et-Cuire', href: '/depannage-menuiserie-caluire-et-cuire/' },
  { label: 'Vénissieux', href: '/depannage-menuiserie-venissieux/' },
  { label: 'Bron', href: '/depannage-menuiserie-bron/' },
  { label: 'Vaulx-en-Velin', href: '/depannage-menuiserie-vaulx-en-velin/' },
  { label: 'Saint-Priest', href: '/depannage-menuiserie-saint-priest/' },
  { label: 'Tassin-la-Demi-Lune', href: '/depannage-menuiserie-tassin-la-demi-lune/' },
  { label: 'Écully', href: '/depannage-menuiserie-ecully/' },
  { label: 'Sainte-Foy-lès-Lyon', href: '/depannage-menuiserie-sainte-foy-les-lyon/' },
  { label: 'Oullins-Pierre-Bénite', href: '/depannage-menuiserie-oullins-pierre-benite/' },
  { label: 'Francheville', href: '/depannage-menuiserie-francheville/' },
  { label: 'Saint-Genis-Laval' },
  { label: 'Meyzieu', href: '/depannage-menuiserie-meyzieu/' },
  { label: 'Décines-Charpieu', href: '/depannage-menuiserie-decines-charpieu/' },
  { label: 'Rillieux-la-Pape', href: '/depannage-menuiserie-rillieux-la-pape/' },
  { label: 'Saint-Fons', href: '/depannage-menuiserie-saint-fons/' },
];

const etapes = [
  { num: '01', title: 'Appelez-nous', desc: 'Décrivez-nous votre panne. Notre technicien vous pose les bonnes questions pour préparer l\'intervention.' },
  { num: '02', title: 'Devis gratuit', desc: 'Nous vous établissons un devis clair et détaillé, sans engagement. Prix transparent, aucune surprise.' },
  { num: '03', title: 'Intervention 24-48h', desc: 'Notre technicien se déplace chez vous, à Lyon ou dans la métropole, avec les pièces nécessaires.' },
  { num: '04', title: 'Garantie 10 ans', desc: 'Votre réparation est couverte par notre garantie décennale. Vous êtes tranquille pour longtemps.' },
];

export default function Home() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  return (
    <>
      <SEOHead
        title="Dépannage volet roulant & fenêtre à Lyon | DFPRO Lyon"
        description="Dépannage et réparation de volets roulants, fenêtres, stores et vitrages à Lyon. Intervention 24-48h, 7j/7. Devis gratuit, garantie 10 ans. Appelez !"
        canonicalUrl="https://depanfenetres-lyon.fr/"
        jsonLd={faqJsonLd}
      />

      <Header />

      <main>
        {/* === HERO === */}
        <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center">
          <div className="absolute inset-0">
            <img
              src="/images/dfpro-hero-2026.jpg"
              alt="Dépannage de volet roulant et fenêtre à Lyon par DFPRO Lyon - technicien en intervention"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/50 via-foreground-900/35 to-foreground-900/50"></div>
          </div>

          <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-heading font-bold text-2xl md:text-4xl lg:text-5xl text-background-50 leading-tight">
                Dépannage de volet roulant et fenêtre à Lyon
              </h1>
              <p className="mt-4 md:mt-6 text-sm md:text-lg text-background-50/90 max-w-2xl mx-auto leading-relaxed">
                Volet roulant bloqué, fenêtre qui ne ferme plus, vitre cassée ? Nos techniciens interviennent rapidement à Lyon et dans toute la métropole, 7j/7. Diagnostic et devis gratuits.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="tel:+33980803684"
                  className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-sm md:text-base px-6 py-3.5 rounded-md transition-colors whitespace-nowrap cursor-pointer shadow-[0_2px_8px_rgba(242,140,40,0.4)]"
                >
                  <i className="ri-phone-fill text-lg w-5 h-5 flex items-center justify-center"></i>
                  Appeler le 09 80 80 36 84
                </a>
                <a
                  href="/contact/"
                  className="inline-flex items-center gap-2 border-2 border-background-50/60 hover:border-background-50 text-background-50 font-semibold text-sm md:text-base px-6 py-3.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-file-list-3-line w-5 h-5 flex items-center justify-center"></i>
                  Devis gratuit
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* === RÉASSURANCE === */}
        <ReassuranceBar />

        {/* === NOS SERVICES === */}
        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-800">
                Nos services de dépannage à Lyon
              </h2>
              <p className="mt-3 text-sm md:text-base text-secondary-500 max-w-2xl mx-auto">
                De la réparation de votre volet roulant au remplacement de vitrage, nous couvrons tous vos besoins en menuiserie. Intervention dans tout Lyon et la métropole.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {services.map((srv, idx) => (
                <ServiceCard key={idx} {...srv} />
              ))}
            </div>
          </div>
        </section>

        {/* === POURQUOI DFPRO LYON === */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-800">
                Pourquoi choisir DFPRO Lyon ?
              </h2>
              <p className="mt-3 text-sm md:text-base text-secondary-500 max-w-2xl mx-auto">
                Une entreprise de dépannage de menuiseries qui mise sur la transparence et la qualité d'intervention.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {[
                { icon: 'ri-flashlight-line', title: 'Intervention rapide', desc: 'Nous nous déplaçons sous 24 à 48h après votre appel, 7j/7 de 7h à 21h. Votre urgence est notre priorité.' },
                { icon: 'ri-tools-line', title: 'Techniciens qualifiés', desc: 'Nos techniciens sont spécialisés en menuiserie et formés aux dernières technologies de volets roulants et fenêtres.' },
                { icon: 'ri-stack-line', title: 'Toutes marques', desc: 'Somfy, Bubendorff, Profalux, Nice, Velux, Franciaflex… Nous maîtrisons l\'ensemble des équipements du marché.' },
                { icon: 'ri-price-tag-3-line', title: 'Devis clair, sans surprise', desc: 'Un diagnostic transparent, un devis détaillé avant toute intervention. Pas de frais cachés, pas de mauvaise surprise.' },
              ].map((item, idx) => (
                <div key={idx} className="text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 mx-auto rounded-md bg-primary-50 flex items-center justify-center">
                    <i className={`${item.icon} text-primary-500 text-2xl w-6 h-6 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="mt-4 font-heading font-semibold text-base text-foreground-800">{item.title}</h3>
                  <p className="mt-2 text-sm text-secondary-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* === COMMENT ÇA SE PASSE === */}
        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-800">
                Comment se passe votre dépannage ?
              </h2>
              <p className="mt-3 text-sm md:text-base text-secondary-500 max-w-2xl mx-auto">
                Un processus simple et rapide pour résoudre votre panne de menuiserie à Lyon.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {etapes.map((etape, idx) => (
                <div key={idx} className="relative text-center">
                  <div className="w-12 h-12 mx-auto rounded-full bg-primary-500 flex items-center justify-center">
                    <span className="font-heading font-bold text-sm text-background-50">{etape.num}</span>
                  </div>
                  {idx < etapes.length - 1 && (
                    <div className="hidden lg:block absolute top-6 left-[calc(50%+2rem)] w-[calc(100%-4rem)] h-px bg-background-300"></div>
                  )}
                  <h3 className="mt-4 font-heading font-semibold text-base text-foreground-800">{etape.title}</h3>
                  <p className="mt-2 text-sm text-secondary-500 leading-relaxed">{etape.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* === ZONE D'INTERVENTION === */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-800">
                Zone d'intervention
              </h2>
              <p className="mt-3 text-sm md:text-base text-secondary-500 max-w-2xl mx-auto">
                Nous intervenons dans tout Lyon et les communes de la Métropole de Lyon. Pas besoin d'avoir une agence dans votre quartier : nous nous déplaçons chez vous.
              </p>
            </div>
            <div className="flex flex-wrap justify-center gap-2 md:gap-3">
              {villes.map((ville, idx) => (
                ville.href ? (
                  <a
                    key={idx}
                    href={ville.href}
                    className="inline-flex items-center px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs md:text-sm text-secondary-500 font-medium hover:text-primary-500 hover:border-primary-300 transition-colors cursor-pointer no-underline"
                  >
                    <i className="ri-map-pin-line text-primary-400 mr-1.5 w-3.5 h-3.5 flex items-center justify-center"></i>
                    {ville.label}
                  </a>
                ) : (
                  <span
                    key={idx}
                    className="inline-flex items-center px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs md:text-sm text-secondary-500 font-medium"
                  >
                    <i className="ri-map-pin-line text-primary-400 mr-1.5 w-3.5 h-3.5 flex items-center justify-center"></i>
                    {ville.label}
                  </span>
                )
              ))}
            </div>
          </div>
        </section>

        {/* === MARQUES TRAITÉES === */}
        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-800">
                Marques traitées
              </h2>
              <p className="mt-3 text-sm md:text-base text-secondary-500 max-w-2xl mx-auto">
                Nous intervenons sur les équipements de toutes les grandes marques de menuiseries et de motorisation.
              </p>
            </div>
            <div className="flex flex-wrap justify-center gap-4 md:gap-8">
              {['Somfy', 'Bubendorff', 'Profalux', 'Nice', 'Velux', 'Franciaflex', 'Simu', 'Faver'].map((marque, idx) => (
                <div key={idx} className="text-center">
                  <span className="font-heading font-semibold text-lg md:text-xl text-foreground-800 bg-background-100 px-5 py-3 rounded-md inline-block">
                    {marque}
                  </span>
                </div>
              ))}
            </div>
            <p className="text-center mt-6 text-xs text-secondary-400 max-w-3xl mx-auto leading-relaxed">
              Somfy, Bubendorff, Velux, Profalux, Nice, Franciaflex, Simu et Faver sont des marques déposées par leurs propriétaires respectifs. DFPRO Lyon (DF PRO) n'est affiliée à aucune de ces marques et intervient sur ces équipements en tant que réparateur indépendant.
            </p>
          </div>
        </section>

        {/* === FAQ === */}
        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-800">
                Questions fréquentes
              </h2>
              <p className="mt-3 text-sm md:text-base text-secondary-500">
                Les réponses aux questions que vous vous posez sur nos services de dépannage à Lyon.
              </p>
            </div>
            <div className="space-y-3">
              {faqData.map((item, idx) => (
                <div key={idx} className="bg-background-50 rounded-lg border border-background-200 overflow-hidden">
                  <button
                    onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading font-semibold text-sm md:text-base text-foreground-800 pr-4">{item.q}</span>
                    <span className={`flex-shrink-0 transition-transform duration-200 ${openFaq === idx ? 'rotate-180' : ''}`}>
                      <i className="ri-arrow-down-s-line text-secondary-400 w-5 h-5 flex items-center justify-center"></i>
                    </span>
                  </button>
                  {openFaq === idx && (
                    <div className="px-5 pb-4">
                      <p className="text-sm text-secondary-500 leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* === CTA FINAL === */}
        <CTABanner
          title="Une panne de volet roulant ou de fenêtre à Lyon ?"
          subtitle="Appelez-nous au 09 80 80 36 84 pour un dépannage rapide. Devis gratuit et sans engagement."
          buttonText="Appeler maintenant"
          secondaryButtonText="Demander un devis"
          secondaryButtonHref="/contact/"
        />
      </main>

      <Footer />
    </>
  );
}